var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon8(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.41723 1.82376C8.62993 1.7056 8.73628 1.64651 8.84891 1.62335C8.94859 1.60285 9.05141 1.60285 9.15109 1.62335C9.26372 1.64651 9.37007 1.7056 9.58277 1.82376L15.1328 4.9071C15.3574 5.0319 15.4697 5.0943 15.5515 5.18305C15.6239 5.26157 15.6786 5.35463 15.7121 5.45601C15.75 5.57061 15.75 5.6991 15.75 5.95609V12.0439C15.75 12.3009 15.75 12.4294 15.7121 12.544C15.6786 12.6454 15.6239 12.7384 15.5515 12.817C15.4697 12.9057 15.3574 12.9681 15.1328 13.0929L9.58277 16.1762C9.37007 16.2944 9.26372 16.3535 9.15109 16.3767C9.05141 16.3972 8.94859 16.3972 8.84891 16.3767C8.73628 16.3535 8.62993 16.2944 8.41723 16.1762L2.86723 13.0929C2.64259 12.9681 2.53026 12.9057 2.44847 12.817C2.37612 12.7384 2.32136 12.6454 2.28786 12.544C2.25 12.4294 2.25 12.3009 2.25 12.0439V5.95609C2.25 5.6991 2.25 5.57061 2.28786 5.45601C2.32136 5.35463 2.37612 5.26157 2.44847 5.18305C2.53026 5.0943 2.64259 5.0319 2.86723 4.9071L8.41723 1.82376Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon8);
export default __webpack_public_path__ + "static/media/icon-8.949a6623e6ef4dc4e4a33607ed85c915.svg";
export { ForwardRef as ReactComponent };